import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-windy',
  templateUrl: './windy.component.html',
  styleUrls: ['./windy.component.scss'],
})
export class WindyComponent implements OnInit {

  @Input() latitude: number;
  @Input() longitude: number;
  @Input() selectedOp: boolean;

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
  ) {
    console.log('Windy latitude:', this.latitude);
    console.log('Windy longitude:', this.longitude);
  }

  ngOnInit() {
}

  getIframeSrc(): SafeResourceUrl {
    let url;
    !environment.production&&console.log('lat',this.latitude,'long',this.longitude)
    if (this.selectedOp) {
      url = `https://embed.windy.com/embed2.html?lat=${this.latitude}&lon=${this.longitude}&detailLat=${this.latitude}&detailLon=${this.longitude}&width=650&height=650&zoom=5&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=&calendar=now&pressure=false&type=map&location=coordinates&detail=true&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1`;
    } else {
      url = `https://embed.windy.com/embed2.html?lat=${this.latitude}&lon=${this.longitude}&detailLat=${this.latitude}&detailLon=${this.longitude}&width=650&height=650&zoom=5&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=&calendar=now&pressure=false&type=map&location=coordinates&detail=true&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1`;
    }
    //same URL now, with different locations (selecte operation location or UPC location)
    //old url: https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=m/s&zoom=6&overlay=wind&product=ecmwf&level=surface&lat=40.128&lon=4.395&detailLat=41.624&detailLon=2.483&detail=true"
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

}
